(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluff-hero"] && !Shopify.designMode) return;
  try {
    
// Any necessary JavaScript can go here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coral-reef-hero"] && !Shopify.designMode) return;
  try {
    
// Carousel functionality
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  if (!carousel) return;

  let index = 0;
  const images = carousel.querySelectorAll(".carousel-image");
  const total = images.length;

  const updateCarousel = () => {
    images.forEach((img, i) => {
      img.style.display = i === index ? "block" : "none";
    });
  };

  document.querySelector(".carousel-prev").addEventListener("click", () => {
    index = (index - 1 + total) % total;
    updateCarousel();
  });

  document.querySelector(".carousel-next").addEventListener("click", () => {
    index = (index + 1) % total;
    updateCarousel();
  });

  updateCarousel();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["discover-banner"] && !Shopify.designMode) return;
  try {
    
  // Add subtle animations
  document.addEventListener('DOMContentLoaded', () => {
    // Animate buttons on hover
    const buttons = document.querySelectorAll('.btn');
    buttons.forEach(button => {
      button.addEventListener('mouseenter', () => {
        button.style.transform = 'translateY(-2px)';
      });
      button.addEventListener('mouseleave', () => {
        button.style.transform = 'translateY(0)';
      });
    });
    
    // Adjust video height on resize
    function adjustVideoHeight() {
      const banner = document.querySelector('.oassis-banner');
      const videoBg = document.querySelector('.video-background');
      if (banner && videoBg) {
        videoBg.style.height = banner.offsetHeight + 'px';
      }
    }
    
    // Initial adjustment
    adjustVideoHeight();
    
    // Adjust on window resize
    window.addEventListener('resize', adjustVideoHeight);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grove-hero"] && !Shopify.designMode) return;
  try {
    
// Carousel functionality
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  if (!carousel) return;

  let index = 0;
  const images = carousel.querySelectorAll(".carousel-image");
  const total = images.length;

  const updateCarousel = () => {
    images.forEach((img, i) => {
      img.style.display = i === index ? "block" : "none";
    });
  };

  document.querySelector(".carousel-prev").addEventListener("click", () => {
    index = (index - 1 + total) % total;
    updateCarousel();
  });

  document.querySelector(".carousel-next").addEventListener("click", () => {
    index = (index + 1) % total;
    updateCarousel();
  });

  updateCarousel();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["james-hero"] && !Shopify.designMode) return;
  try {
    
// Carousel functionality
document.addEventListener("DOMContentLoaded", function () {
  const carousel = document.querySelector(".carousel");
  if (!carousel) return;

  let index = 0;
  const images = carousel.querySelectorAll(".carousel-image");
  const total = images.length;

  const updateCarousel = () => {
    images.forEach((img, i) => {
      img.style.display = i === index ? "block" : "none";
    });
  };

  document.querySelector(".carousel-prev").addEventListener("click", () => {
    index = (index - 1 + total) % total;
    updateCarousel();
  });

  document.querySelector(".carousel-next").addEventListener("click", () => {
    index = (index + 1) % total;
    updateCarousel();
  });

  updateCarousel();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-Cta"] && !Shopify.designMode) return;
  try {
    
  // Simple testimonial slider functionality
  document.addEventListener('DOMContentLoaded', function() {
    const slider = document.querySelector('.testimonial-slider');
    const slides = document.querySelectorAll('.testimonial-slide');
    const dots = document.querySelectorAll('.slider-dot');
    let currentSlide = 0;
    
    if (!slider || !slides.length) return;
    
    // Set initial position
    updateSlider();
    
    // Add click events to dots
    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        currentSlide = index;
        updateSlider();
      });
    });
    
    // Auto slide every 5 seconds
    setInterval(() => {
      currentSlide = (currentSlide + 1) % slides.length;
      updateSlider();
    }, 5000);
    
    function updateSlider() {
      slider.style.transform = `translateX(-${currentSlide * 100}%)`;
      
      // Update active dot
      dots.forEach((dot, index) => {
        if (index === currentSlide) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
